import {PendingEditor} from '../types/PendingEditor';

/** Saves the editors one after another and stops at the first editor that reports a failure. */
export function savePendingEditors(editors: PendingEditor[]) {
  return editors.reduce<Promise<boolean>>(
    (saveSequence, editor) => saveSequence.then((isSuccessful) => isSuccessful && editor.save()),
    Promise.resolve(true)
  );
}
